module.exports = __webpack_public_path__ + "img/Zuckerperlen.ea7dbda8.jpg";